import { useEffect, useState } from "react";
import logo from "../../assets/logo.webp";
import phone from "../../assets/phone.svg";
import arrowUp from "../../assets/arrow-up.svg";
import Button from "../Button";

export default function Nav() {
  const scrollToSection = (
    e: React.MouseEvent<HTMLAnchorElement>,
    id: string
  ) => {
    e.preventDefault();
    const section = document.getElementById(id);
    if (section) {
      section.scrollIntoView({ behavior: "smooth", block: "center" });
    }
  };

  const [selected, setSelected] = useState("");
  const [showUp, setShowUp] = useState(false);
  const handleScroll = () => {
    if (window.scrollY > 100) {
      setShowUp(true);
    } else {
      setShowUp(false);
    }
  };

  useEffect(() => {
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const navLinks = [
    { id: "cremation", label: "Cremazioni" },
    { id: "funeral", label: "Funerali" },
    { id: "contact", label: "Contatti" },
  ];

  const linksDesktop = (
    <div className="d-flex justify-content-center align-items-center gap-4">
      {navLinks.map((link) => (
        <u key={link.id}>
          <a
            id={`nav-${link.id}`}
            className="d-flex"
            href={`#${link.id}`}
            onClick={(e) => scrollToSection(e, link.id)}
          >
            {link.label}
          </a>
        </u>
      ))}
    </div>
  );

  const linksMobile = (
    <div
      style={{ justifyContent: "space-between" }}
      className="d-flex w100 mt-2"
    >
      {navLinks.map((link) => (
        <u
          style={{
            flexGrow: "1",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            height: "35px",
            textDecoration: "none",
          }}
          key={link.id}
        >
          <a
            style={{
              paddingBottom: "5px",
              height: "100%",
              width: "100%",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              textDecoration: "none",
              borderBottom: `4px solid ${
                selected === link.id ? "rgb(43, 62, 91)" : "transparent"
              }`,
              color: selected === link.id ? "#000" : "#000",
              fontWeight: selected === link.id ? "bold" : "normal",
            }}
            id={`nav-${link.id}`}
            className="d-flex"
            href={`#${link.id}`}
            onClick={(e) => {
              scrollToSection(e, link.id);
              setSelected(link.id);
            }}
          >
            {link.label}
          </a>
        </u>
      ))}
    </div>
  );

  return (
    <>
      {showUp && (
        <div
          style={{
            position: "fixed",
            bottom: "20px",
            right: "20px",
            zIndex: 1000,
            height: "50px",
            width: "50px",
            backgroundColor: "white",
            borderRadius: "50%",
            boxShadow: "0 0 10px rgba(0, 0, 0, 0.5)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            cursor: "pointer",
          }}
          onClick={() => {
            window.scrollTo({
              top: 0,
              behavior: "smooth",
            });

            setSelected("");
          }}
        >
          <img style={{ height: "70%" }} src={arrowUp} alt="" />
        </div>
      )}

      <nav className="pb-lg-2 pb-lg-0">
        <div className="container">
          <div className="content">
            <div className="d-flex justify-content-between pt-3 pt-md-3 pb-lg-3">
              <div className="logo mt-auto m-lg-0">
                <img src={logo} alt="logo parisi mario onoranze funebri" />
              </div>
              <div className="d-none d-lg-flex">{linksDesktop}</div>
              <div className="d-flex flex-column align-items-center">
                <Button
                  id="cta-1"
                  onClickLink={`tel:${process.env.REACT_APP_PHONE_NUMBER}`}
                  text={`348 419 16 93 (24h)`}
                  icon={phone}
                  className="tag-manager-call"
                />
              </div>
            </div>
          </div>
        </div>
        <div className="d-flex justify-content-center d-lg-none mt-2 border-top">
          {linksMobile}
        </div>
      </nav>
    </>
  );
}
